import { PersonnelRegistration } from "./PersonnelRegistration";
export default PersonnelRegistration;
